<template>
  <div
    class="tw:bg-orange-200 tw:py-4 tw:px-5 tw:rounded-xl tw:flex tw:flex-col tw:md:flex-row tw:gap-4 tw:md:items-center"
  >
    <div
      class="tw:bg-orange-300 tw:rounded-full tw:flex tw:items-center tw:justify-center tw:flex-shrink-0 tw:w-14 tw:h-14"
    >
      <img
        :src="infoIcon"
        role="presentation"
        alt=""
        class="tw:w-6 tw:h-6 tw:object-contain tw:bg-white tw:rounded-full"
      />
    </div>
    <div class="tw:w-full tw:flex tw:flex-col tw:gap-x-[2px]">
      <p class="tw:font-bold tw:text-sm" v-html="$t('subscription_expiring_info', { ActiveDate: endDate })" />
      <p class="tw:text-sm">{{ $t('subscription_expiring_subtext') }}</p>
    </div>
    <GhostButton v-if="isPro" class="tw:text-nowrap" @click="startProToPlusReactivation">{{
      $t('business_studio_plus_reactivate_cta')
    }}</GhostButton>
    <GhostButton v-else class="tw:text-nowrap" @click="startReactivation">{{
      $t('reactivate_plus_subscription_cta')
    }}</GhostButton>
  </div>
</template>
<script setup>
import { computed } from 'vue'

import GhostButton from '@/components/base/buttons/GhostButton.vue'

import { useStudioPlusCampaign } from '@/components/payment/queries'
import { useStudioPlusReactivation } from '@/components/billing/premiumProducts/reactivation/useStudioPlusReactivation'
import { useProToPlusReactivation } from '@/components/billing/premiumProducts/reactivation/useProToPlusReactivation'
import { selectedAccommodationId } from '@/layouts/queries'
import { useFormatting } from '@/composables/useFormatting'

import appAnalytics from '@/utils/tracking'

const infoIcon = new URL('/src/assets/img/studio-plus-insights/info-icon.svg', import.meta.url)

const { formatDate } = useFormatting()
const { studioPlusCampaign, isPro } = useStudioPlusCampaign(selectedAccommodationId)
const { openReactivationModal } = useStudioPlusReactivation()
const { openProToPlusModal } = useProToPlusReactivation()

const startReactivation = () => {
  if (!selectedAccommodationId.value) return
  appAnalytics.track(appAnalytics.events.SP_PLUS_INSIGHTS_REACTIVATION_CTA_CLICKED, {
    item_id: selectedAccommodationId.value,
    reactivation_source: 'Business Studio+ Insights Notification',
  })
  openReactivationModal(selectedAccommodationId, 'business-studio-insights-performance-notification')
}

const startProToPlusReactivation = () => {
  if (!selectedAccommodationId.value) return
  appAnalytics.track(appAnalytics.events.PRO_TO_PLUS_MODAL_OPENED, {
    item_id: selectedAccommodationId.value,
    source: 'plus_insights',
  })
  openProToPlusModal(selectedAccommodationId.value, 'plus_insights')
}

const endDate = computed(() => {
  const rawDate = studioPlusCampaign.value?.endDate
  if (!rawDate) return ''
  return formatDate(rawDate)
})
</script>
